import { HelpCircle } from "lucide-react";
import { SimpleAccordion } from "@/components/SimpleAccordion";
import { useLang } from "@/context/LanguageContext";
import { tr } from "@/lib/translations";
import { richText } from "@/lib/richText";
import { useJsonLd } from "@/lib/useSeo";
import { useTextVars, applyVars } from "@/lib/textVars";

/** Startseite „Häufige Fragen“ (settings.home_faq) mit schema.org FAQPage. */
export const HomeFaq = ({ items }) => {
  const { t, lang } = useLang();
  const vars = useTextVars();
  const faq = (items || []).map((f) => ({ id: f.id, q: applyVars(tr(f.q, lang), vars), a: applyVars(tr(f.a, lang), vars) })).filter((f) => f.q && f.a);
  useJsonLd(faq.length ? [{ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) }] : []);
  if (!faq.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 home-section border-t border-stone-200" data-testid="home-faq">
      <div className="home-section-head">
        <div className="text-xs uppercase tracking-[0.3em] text-brand flex items-center gap-2"><HelpCircle className="w-4 h-4" />{t.faqSection.subtitle}</div>
        <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mt-3">{t.faqSection.title}</h2>
      </div>
      <SimpleAccordion testId="home-faq" className="border-t border-stone-200 max-w-4xl" items={faq.map((f, i) => ({ key: f.id || i, title: f.q, content: richText(f.a) }))} />
    </section>
  );
};
